import { render, staticRenderFns } from "./FinalizedOrderItemsTable.vue?vue&type=template&id=e36d0d26&"
import script from "./FinalizedOrderItemsTable.vue?vue&type=script&lang=js&"
export * from "./FinalizedOrderItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports